import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React, { useState } from 'react'
import UploadBadge from '../../components/UploadBadge'
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store/slices/common';
import { editBadge } from '../../http/badges';
import CustomTextField from '../../components/FormElements/CustomTextField';

const AddBadgeModal = ({ openDialog, handleCloseDialog, classes, edit, selectedBadge, setSelectedBadge, getList }) => {
    const [image, setImage] = useState();
    const dispatch = useDispatch()

    const changeBadgeHandler = async (e) => {
        e.preventDefault()
        try {
            dispatch(setLoading(true))
            const payload = { ...selectedBadge, logo: image, id: selectedBadge?._id }
            await editBadge(payload)
            await getList()
            handleCloseDialog()
        } catch (err) {
            console.log(err)
        } finally {
            dispatch(setLoading(false))
        }
    }

    const handleImageUpload = (file) => {
        setImage(file);
    };

    const handleClose = () => {
        handleCloseDialog();
    };

    const handleBackdropClick = (e) => {
        e.stopPropagation()
    }


    return (
        <Dialog sx={{
            zIndex: 9, '& .MuiDialog-container .MuiPaper-elevation': {
                borderRadius: '8px', width: '420px'
            }
        }} open={openDialog}
            onClick={handleBackdropClick}
            onClose={handleClose}>
            <DialogTitle sx={{
                padding: '30px 0 15px', textAlign: 'center', fontWeight: 700
            }}>Edit Badge</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <form >
                    <Box mt={1}>
                        <CustomTextField
                            label="Title of the badge"
                            value={selectedBadge?.title}
                            inputProps={{ readOnly: true }}
                        />
                    </Box>
                    <Box mt={2}>
                        <CustomTextField
                            label="Badge Category"
                            value={selectedBadge?.category}
                            inputProps={{ readOnly: true }}
                        />
                    </Box>
                    <Box mt={2}>
                        <CustomTextField
                            label="Description"
                            value={selectedBadge?.shortDescription}
                            multiline
                            rows={2}
                            inputProps={{ readOnly: true }}
                            isBadge={true}
                        />
                    </Box>
                    <Box sx={{ marginTop: '16px' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '14px', marginBottom: '16px' }}> Add Badge </Typography>
                        <UploadBadge onImageUpload={handleImageUpload} selectedBadge={selectedBadge} edit={edit} setSelectedBadge={setSelectedBadge} />
                    </Box>
                    <Box className={classes.actionsContainer}>
                        <Button sx={{
                            border: '1px solid #888',
                            color: '#888',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginRight: '15px',
                            '&:hover': {
                                backgroundColor: '#b9b9b9', color: '#222', borderColor: '#b9b9b9'
                            }
                        }} onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button
                            className={classes.button}
                            type="submit"
                            onClick={changeBadgeHandler}
                            disabled={!image || (image === selectedBadge?.logo)}
                            sx={{ opacity: (!image || (image === selectedBadge?.logo)) ? 0.5 : 1 }}
                        >
                            Update Badge
                        </Button>
                    </Box>
                </form >
            </DialogContent>
        </Dialog>
    )
}

export default AddBadgeModal
